<script setup>
import logger from "~/shared/utils/logger";
  const route = useRoute()
  const queryName = route.path.slice(1).replace(/\//g, "_") + '-hub'

  const { data: allArticles } = await useAsyncData(queryName, () => {
    return import.meta.env.PROD ? queryCollection('content').where('published', '==', PublishedStatusEnum.Published).order('title', 'ASC').all() : queryCollection('content').order('title', 'ASC').all()
  });

  logger.log(`ProjectHub rootPath: ${route.path}, queryName: ${queryName}, fetched ${allArticles.value.length} articles.`);

  
  const hubInArray = allArticles.value.filter(project => project.content_type === ContentTypeEnum.Hub && project.path === route.path);
  const hub = hubInArray[0] ? { ...hubInArray[0]} : null;

  if(!hub || !hub.project) {
    console.error("ProjectHub: no project named", hub ? hub.project : "undefined", "found for path", route.path, "Check your content collection and ensure there is a document with content_type: Hub and path:", route.path);
  }

  const guides = allArticles.value.filter(guide => 
    guide.content_type === ContentTypeEnum.Guide &&
    guide.path.startsWith(hub ? hub.path : undefined) &&
    guide.project === hub.project
  );

  logger.log(`ProjectHub: found ${guides.length} guides for project ${hub ? hub.project : "undefined"}`);

  for (const guide of guides) {
    guide.chapters = allArticles.value.filter(article => 
      article.content_type != ContentTypeEnum.Guide &&
      article.content_type != ContentTypeEnum.Hub &&
      article.content_type != ContentTypeEnum.Index &&
      article.path.startsWith(guide.path) &&
      article.guide === guide.guide &&
      article.peer_order > 0
    ).sort((a, b) => (a.peer_order || 0) - (b.peer_order || 0)); // sort chapters by peer_order

    logger.log(`Guide: ${guide.title}, path: ${guide.path}, guide chapters: ${guide.chapters.length}`);
  }

  const articles = allArticles.value.filter(article => 
    article.path.startsWith(hub ? hub.path : undefined) &&
    !article.guide &&
    article.content_type != ContentTypeEnum.Guide &&
    article.content_type != ContentTypeEnum.Hub &&
    article.content_type != ContentTypeEnum.Index
  );

  const cheats = allArticles.value.filter(ref => 
    ref.projects &&
    ref.path.startsWith('/cheats') &&
    ref.projects.includes(hub.project)
  );

  const posts = computed(() => {
    if(!allArticles.value) return []

    const postsNormalized = [], postsListDate = []
    let lastYear = null;
    const allPosts = allArticles.value.filter(post => 
      post.projects &&
      post.path.startsWith('/blog') &&
      post.projects.includes(hub.project)
    );

    // Ensure all posts have date_created and date_modified
    for(const post of allPosts) {
      postsNormalized.push(normalizeDates(post))
    }

    // Sort posts by date_modified DESC
    postsNormalized.sort((a, b) => {
      const dateA = new Date(a['date_modified'])
      const dateB = new Date(b['date_modified'])
      return (dateA < dateB) ? 1 : -1
    })

    // Add isDisplayYear flag based on sorted position
    let count = 0;

    for (const post of postsNormalized) {
      count++;
      post.isDisplayYear = post.year !== lastYear || count >= postsNormalized.length
      lastYear = post.year
      postsListDate.push(post)
    }
    return postsListDate
  })


</script>

<template>
  <div class="grid grid-cols-10 gap-4">
    <div class="col-span-9 lg:col-span-10">
      <h3 v-if="guides.length" class="article-header">Guides</h3>
      <ArticleLink v-for="guide in guides" :key="guide.path" :article="guide" />
      <h3 v-if="articles.length" class="article-header">Articles</h3>
      <ArticleLink v-for="article in articles" :key="article.path" :article="article" />
      <h3 v-if="hub.repos && hub.repos.length" class="article-header">Repos</h3>
      <GitProjectsList v-if="hub.repos && hub.repos.length" :repo-names="hub.repos" />
      <h3 v-if="posts.length" class="article-header">Blog</h3>
      <ArticleLink v-for="post in posts" :key="post.path" :article="post" />
      <h3 v-if="cheats.length" class="article-header">Cheat Sheets</h3>
      <ArticleLink v-for="ref in cheats" :key="ref.path" :article="ref" />
    </div>

  </div>
</template>

<style lang="css" scoped>

.article-list:nth-child(even), .article-list:first-child {
    @apply bg-gray-200 dark:bg-gray-700;
}
</style>